import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { RootState } from '../../store/store'

interface IProps {}

export const ProtectedRoute: FC<IProps> = (props) => {
  const UserLogued = useSelector((state: RootState) => state.UserProfile.UserProfile.logueado)
  return UserLogued ? <Outlet /> : <Navigate to='/' />
}
